import React, { useState, useRef } from 'react'

import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import TextField from '@material-ui/core/TextField'
import Select from '@material-ui/core/Select'
import CounterLeads from 'src/components/leads/counterLeads'
import MenuItem from '@material-ui/core/MenuItem'
import Grid from '@material-ui/core/Grid'
import DateFnsUtils from '@date-io/date-fns'
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers'

import { Autocomplete } from '@material-ui/lab'
import { useStyles } from './styles'

const searchInitial = {
  marca: null,
  ciudad: null,
  vehiculo: null,
  testdrive: '',
  departamento: null,
  integrado_impulsa: '',
}

const SearchFilter = (props) => {
  const {
    counters,
    vehiculos,
    ciudades,
    marcas,
    handleChange,
    departamentos,
    handleChangeDepartment,
    handleDateInitChange,
    handleDateEndChange,
    selectedDateInit,
    selectedDateEnd,
    qtyLeads,
  } = props
  const [searchControl, setSearchControl] = useState(searchInitial)
  const classes = useStyles()
  // contadores provistos por el backend (COUNT), ya no se calculan en cliente
  const totalLeads = counters?.total ?? 0
  const completosIntegrados = counters?.integrados ?? 0
  const completosNoIntegrados = counters?.no_integrados ?? 0

  const datePickerRef = useRef(null)

  const handleDateAccept = () => {
    console.log(datePickerRef.current)
    // datePickerRef.current.close()
  }

  return (
    <>
      <CounterLeads
        totalLeads={totalLeads}
        completosIntegrados={completosIntegrados}
        completosNoIntegrados={completosNoIntegrados}
        qtyLeads={qtyLeads}
      />
      <div className={classes.contentSearch}>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <Grid container justifyContent="flex-start">
            <KeyboardDatePicker
              className={classes.formControl}
              disableToolbar
              variant="inline"
              format="MM/dd/yyyy"
              margin="normal"
              id="date-picker-inline"
              label="Fecha Inicial"
              value={selectedDateInit}
              defaultValue={selectedDateInit}
              onChange={handleDateInitChange}
              ref={datePickerRef}
              onAccept={handleDateAccept}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
            />
            <KeyboardDatePicker
              className={classes.formControl}
              disableToolbar
              variant="inline"
              format="MM/dd/yyyy"
              margin="normal"
              id="date-picker-inline"
              label="Fecha Final"
              value={selectedDateEnd}
              defaultValue={selectedDateEnd}
              onChange={handleDateEndChange}
              ref={datePickerRef}
              onAccept={handleDateAccept}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
            />
          </Grid>
        </MuiPickersUtilsProvider>
        <FormControl className={classes.formControl}>
          <Autocomplete
            noOptionsText="Sin opciones"
            value={searchControl.departamento}
            options={departamentos}
            getOptionLabel={(option) => option.NOMBRE_DPT}
            renderInput={(params) => (
              <TextField {...params} label="Departamento" />
            )}
            onChange={(e, newVal) => {
              const choose = newVal ? newVal.NOMBRE_DPT : null
              setSearchControl({
                ...searchControl,
                departamento: newVal,
                ciudad: null,
              })
              handleChangeDepartment('departamento', choose)
            }}
          />
        </FormControl>
        <FormControl className={classes.formControl}>
          <Autocomplete
            noOptionsText="Sin opciones"
            value={searchControl.ciudad}
            options={ciudades}
            getOptionLabel={(option) => option.NOMBRE_MPI}
            renderInput={(params) => <TextField {...params} label="Ciudad" />}
            onChange={(e, newVal) => {
              const choose = newVal ? newVal.NOMBRE_MPI : null
              setSearchControl({
                ...searchControl,
                ciudad: newVal,
              })
              handleChange('ciudad', choose)
            }}
          />
        </FormControl>
        <FormControl className={classes.formControl}>
          <Autocomplete
            noOptionsText="Sin opciones"
            value={searchControl.marca}
            options={marcas}
            getOptionLabel={(option) => option.marca}
            renderInput={(params) => <TextField {...params} label="Marca" />}
            onChange={(e, newVal) => {
              const choose = newVal ? newVal.marca : null
              setSearchControl({
                ...searchControl,
                marca: newVal,
              })
              handleChange('marca', choose)
            }}
          />
        </FormControl>
        <FormControl className={classes.formControl}>
          <Autocomplete
            noOptionsText="Sin opciones"
            value={searchControl.vehiculo}
            options={vehiculos}
            getOptionLabel={(option) => option.linea}
            renderInput={(params) => <TextField {...params} label="Linea" />}
            onChange={(e, newVal) => {
              const choose = newVal ? newVal.linea : null
              setSearchControl({
                ...searchControl,
                vehiculo: newVal,
              })
              handleChange('vehiculo', choose)
            }}
          />
        </FormControl>
        <FormControl className={classes.formControl}>
          <InputLabel htmlFor="socio-native-simple">Integrado?</InputLabel>
          <Select
            className={classes.selectSearch}
            onChange={(e) => {
              setSearchControl({
                ...searchControl,
                integrado_impulsa: e.target.value,
              })
              handleChange('integrado_impulsa', e.target.value)
            }}
            inputProps={{
              name: 'estado',
              id: 'socio-native-simple',
            }}
            value={searchControl.integrado_impulsa}
          >
            <MenuItem value={null}>
              <em>Ninguno</em>
            </MenuItem>
            <MenuItem value="SI">Integrado</MenuItem>
            <MenuItem value="NO">No Integrado</MenuItem>
          </Select>
        </FormControl>

        <FormControl className={classes.formControl}>
          <InputLabel htmlFor="socio-native-simple">Test Drive</InputLabel>
          <Select
            value={searchControl.testdrive}
            className={classes.selectSearch}
            onChange={(e) => {
              setSearchControl({ ...searchControl, testdrive: e.target.value })
              handleChange('testdrive', e.target.value)
            }}
            inputProps={{
              name: 'estado',
              id: 'socio-native-simple',
            }}
          >
            <MenuItem value={null}>
              <em>Ninguno</em>
            </MenuItem>
            <MenuItem value="SI">SI</MenuItem>
            <MenuItem value="NO">NO</MenuItem>
          </Select>
        </FormControl>
        <br />
      </div>
    </>
  )
}

export default SearchFilter
